<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 试题类别管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="名称:">
              <el-input placeholder="请输入类别名称" v-model="seefrom.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="230">
              <template slot-scope="scope">
                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.$index, scope.row)">编辑</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <edit-dialog v-model="commandDialog" :status="addStatus" :data="detailData" @refresh="getTableData"></edit-dialog>
  </div>
</template>

<script>
export default {
  name: 'testType',
  data() {
    return {
      tabName: 'jsgl',
      seefrom: {},
      tableData: [],
      detailData: {},
      commandDialog: false,
      nTotal: 0,
      currentPage: 1,
      addStatus: 'adding'
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'name',
          label: '类别名称'
        },
        {
          prop: 'sort',
          label: '序号'
        }
      ]
    }
  },
  components: {
    editDialog: () => import('./editDialog')
  },
  created() {
    this.getTableData()
  },
  methods: {
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    //查询表格数据
    getTableData() {
      this.$axiosget('operation/question/type/page', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    addnew() {
      this.addStatus = 'adding'
      this.commandDialog = true
    },
    // 编辑
    edit(index, row) {
      let data = _.cloneDeep(row)
      this.detailData = data
      this.addStatus = 'editing'
      this.commandDialog = true
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('operation/question/type', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status == '10000') {
            this.getTableData()
            this.$message.success('删除成功!')
          }
        })
      })
    }
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exam/testType/index.vue